<template>
  <div class="classroom">
    <div class="content">
      <div class="row">
        <el-row :gutter="20">
          <el-col :span="8">
            <p>理事单位</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon26.png" />
          </el-col>
          <el-col :span="8">
            <p>副理事长单位</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon27.png" />
          </el-col>
          <el-col :span="8">
            <p>优秀企业</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon28.png" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <p>诚实企业家</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon20.png" />
          </el-col>
          <el-col :span="8">
            <p>海南省诚实守信示范单位</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon21.png" />
          </el-col>
          <el-col :span="8">
            <p>重合同 守信用企业</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon22.png" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <p>三大体系</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon23.png" />
          </el-col>
          <el-col :span="8">
            <p>三大体系</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon24.png" />
          </el-col>
          <el-col :span="8">
            <p>三大体系</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon25.png" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .img{width: 100%;height: auto;}
  .classroom p{text-align: center;font-size: 14px;font-weight: bold;}
  .row {border: 1px solid #f2f2f2;margin-bottom: 20px;border-radius: 10px;padding: 20px;}
  .row div{text-align: center;font-size: 32px;font-weight: bold;}
</style>



// WEBPACK FOOTER //
// src/pages/classroom.vue